<template>
  <b-modal
    id="alert-modal"
    ref="alert-modal"
    size="sm"
    :centered="notification_config.centerAligned"
    :hide-header="notification_config.hideHeader"
    :hide-footer="notification_config.hideFooter"
    :hide-backdrop="notification_config.hideBackdrop"
    v-model="showNotification"
  >
    <div class="alert-modal-body">
      <div class="modal-close">
        <a
          href="javascript:void(0)"
          class
          data-dismiss="modal"
          @click="hideNotification"
        >
          <svg class="closeIcon" fill="none">
            <use xlink:href="#closeIcon" />
          </svg>
        </a>
      </div>
      <div>
        <div class="icon mb-3">
          <template v-if="notification_config.custom_icon">
            <img :src="notification_config.custom_icon" width="78px" height="78px" />
          </template>
          <template v-else>
            <svg
              v-if="notification_config.status == 'success'"
              class="success-icon"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#73AF55"
                stroke-width="8"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <polyline
                class="path check"
                fill="none"
                stroke="#73AF55"
                stroke-width="8"
                stroke-linecap="round"
                stroke-miterlimit="10"
                points="100.2,40.2 51.5,88.8 29.8,67.5 "
              />
            </svg>
            <svg
              v-else-if="notification_config.status == 'error'"
              class="error-icon"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="8"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="8"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="8"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
            <svg
              v-if="notification_config.status == 'alert'"
              class="alert-icon"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="10.099 100.1 591.8 591.8"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    fill="#DA2541"
                    d="M595.346,570.48L351.697,166.408c-9.599-15.918-27.109-25.808-45.698-25.808
        c-18.589,0-36.1,9.89-45.7,25.809L16.651,570.48c-9.921,16.453-10.214,37.066-0.767,53.796
        c9.45,16.73,27.253,27.123,46.465,27.123h487.298c19.212,0,37.018-10.393,46.468-27.123
        C605.562,607.545,605.268,586.932,595.346,570.48z M562.439,605.26c-2.6,4.604-7.503,7.467-12.792,7.467H62.35
        c-5.289,0-10.19-2.861-12.791-7.465c-2.601-4.607-2.52-10.281,0.21-14.811l243.65-404.073c2.643-4.382,7.463-7.105,12.581-7.105
        s9.938,2.723,12.58,7.105l243.648,404.073C564.959,594.981,565.04,600.654,562.439,605.26z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="#DA2541"
                    d="M306.184,296.795c-15.156,0-26.985,8.133-26.985,22.551c0,43.99,5.174,107.203,5.174,151.194
        c0.001,11.459,9.983,16.265,21.813,16.265c8.871,0,21.44-4.806,21.44-16.265c0-43.99,5.174-107.203,5.174-151.194
        C332.8,304.929,320.602,296.795,306.184,296.795z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    fill="#DA2541"
                    d="M306.556,512.312c-16.265,0-28.465,12.938-28.465,28.465c0,15.156,12.199,28.465,28.465,28.465
        c15.156,0,28.096-13.309,28.096-28.465C334.651,525.249,321.711,512.312,306.556,512.312z"
                  />
                </g>
              </g>
            </svg>
          </template>
        </div>
        <p
          class="mb-0"
          :class="notification_config.web_theme ? '' : notification_config.status"
          v-html="notification_config.text"
        ></p>
        <div class="text-center" v-if="notification_config.sub_text" v-html="notification_config.sub_text"></div>

        <div class="alert-modal-footer d-block text-center mt-3">
          <button
            class="btn"
            :class="notification_config.web_theme ? 'btn-solid' : ('btn-' + notification_config.status)"
            @click="handleOkButtonEvent"
          >
            {{ _T(notification_config.ok_button.label || 'OK') }}
          </button>
          <button v-show="notification_config.cancel_button.callback || notification_config.ok_button.callback"
            class="btn btn-outline"
            :class="notification_config.web_theme ? '' :'btn-error'"
            @click="handleCancelButtonEvent"
          >
            {{ _T(notification_config.cancel_button.label || 'Cancel') }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Notification',
  data() {
    return {
      centerAligned: true
    }
  },
  computed: {
    ...mapGetters([
      'notification_config',
      'is_notification_shown',
      '_T',
    ]),
    showNotification() {
      return this.is_notification_shown
    },
  },
  methods: {
    handleOkButtonEvent() {
      if (this.notification_config.ok_button.callback) {
        this.notification_config.ok_button.callback()
      }
      this.handlePopup()
    },
    handleCancelButtonEvent() {
      if (this.notification_config.cancel_button.callback) {
        this.notification_config.cancel_button.callback()
      }
      this.handlePopup()
    },
    handlePopup() {
      if (this.notification_config.redirect_to) {
        this.redirectTo()
      }
      this.hideNotification()
    },
    
    hideNotification() {
      this.$store.dispatch('hideNotification')
    },
    redirectTo() {
      this.$router.push({ name: this.notification_config.redirect_to || 'home' })
      this.hideNotification()
    },
  },
}
</script>

<style lang="scss">
#alert-modal {
  .modal-dialog {
    max-width: $px450;
    .modal-content {
      height: $px250;
      justify-content: center;
      border-radius: $px8;
      // box-shadow: 0px 0px 6px 1px $color-primary;
      .alert-modal-body {
        padding: $px10;
        height: 100%;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        .modal-close {
          position: absolute;
          right: $px5;
          top: $px2;
          svg {
            width: $px18;
            height: $px18;
          }
        }
        .icon {
          text-align: center;
          svg {
            width: $px50;
            display: block;
            margin: 0 auto;
            &.alert-icon {
              margin-bottom: -1rem;
            }
          }
          .path {
            stroke-dasharray: 1000;
            stroke-dashoffset: 0;
            &.circle {
              -webkit-animation: dash 0.9s ease-in-out;
              animation: dash 0.9s ease-in-out;
            }
            &.line {
              stroke-dashoffset: 1000;
              -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
              animation: dash 0.9s 0.35s ease-in-out forwards;
            }
            &.check {
              stroke-dashoffset: -100;
              -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
              animation: dash-check 0.9s 0.35s ease-in-out forwards;
            }
          }
        }
        .btn {
          &.btn-success {
            color: $white !important;
            background-color: #28a745 !important;
            border-color: #28a745 !important;
          }
        }
        p {
          font-size: $px14;
          text-align: center;
          font-weight: 600;
          &.success {
            color: $dine-success;
          }
          &.error {
            color: $color-primary;
          }
        }
      }
      .alert-modal-footer {
        .btn {
          margin-right: $px10;
        }
      }
    }
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
